import { isLoginError, LOGIN_ERROR_MESSAGES } from '@easyhelp/shared';
import GoogleIcon from '@mui/icons-material/Google';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Navigate, useSearchParams } from 'react-router';
import { loginUrl, safeReturnTo, useSession } from '../../api/auth';
import { SUITE_NAME } from '../../shell/SuiteShell';

/** Messaggio per un `?errore=` non previsto (es. un parametro scritto a mano). */
const UNKNOWN_ERROR = 'Accesso non riuscito. Riprova; se il problema persiste avvisa l’amministratore.';

/**
 * Pagina di accesso (PRD-002 US-1, PAGE-005): un solo pulsante, «Accedi con Google», che porta
 * all'API (`/auth/google`) e da lì a Google Workspace. `?returnTo=` è dove tornare dopo il login,
 * `?errore=` il motivo di un rifiuto del callback. Chi è già collegato viene rimandato via.
 */
export function AccessoPage() {
  const [params] = useSearchParams();
  const returnTo = safeReturnTo(params.get('returnTo'));
  const errore = params.get('errore');
  const { data: session, isPending } = useSession();

  if (session) return <Navigate to={returnTo} replace />;

  return (
    <Box
      component="main"
      sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'grey.100', px: 2, py: 6 }}
    >
      <Paper variant="outlined" sx={{ p: { xs: 4, sm: 6 }, width: '100%', maxWidth: 440 }}>
        <Stack spacing={4}>
          <Stack spacing={1}>
            <Typography variant="h4" component="h1">
              {SUITE_NAME}
            </Typography>
            <Typography color="text.secondary">Console interne Easy Health</Typography>
          </Stack>

          {errore !== null && (
            <Alert severity="error">{isLoginError(errore) ? LOGIN_ERROR_MESSAGES[errore] : UNKNOWN_ERROR}</Alert>
          )}

          <Button
            component="a"
            href={loginUrl(returnTo)}
            variant="contained"
            size="large"
            startIcon={<GoogleIcon />}
            disabled={isPending}
          >
            Accedi con Google
          </Button>

          <Typography variant="body2" color="text.secondary">
            Entra con l'account Google Workspace aziendale: nessuna password è conservata qui e la verifica in due
            passaggi è quella del Workspace. Possono entrare solo le persone del Team di supporto.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
